import { Routes, Route, Navigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { lazy, Suspense, useCallback, useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import Loading from "components/Fallbacks/Loading/Loading";
import "./App.css";
// import { mockData } from "utils/Mocks/mockOCGenerator";

const Private = lazy(() => import("./Pages/Private/Private"));
const Landing = lazy(() => import("./Pages/Landing/Landing"));

/**
 * Renders the main App component with authentication check and routing logic.
 *
 * @return {JSX.Element} The rendered main App component
 */
function App() {
  const isAuthenticated = useIsAuthenticated();
  // const routerUrl = process.env.REACT_APP_ROUTER_URL || "";
  const { instance, inProgress } = useMsal();


  // console.log(JSON.stringify(mockData, null, 2));

  const handleLogin = useCallback(
    async (inProgress: InteractionStatus) => {
      if (inProgress === InteractionStatus.None) {
        try {
          await instance.handleRedirectPromise();
        } catch (error) {
          console.error("Error handling redirect:", error);
        }
      }
    },
    [instance]
  );

  useEffect(() => {
    handleLogin(inProgress);
  }, [handleLogin, inProgress, instance]);

  if (inProgress !== InteractionStatus.None) {
    return (
      <div
        style={{
          marginTop: "40vh",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loading />
      </div>
    );
  }

  return (
    <div className="App">
      <Suspense
        fallback={
          <div
            style={{
              marginTop: "40vh",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading />
          </div>
        }
      >
        <Routes>
          {/* <Route path="/" element={<Navigate to={routerUrl} replace />} /> */}
          <Route
            path={"/"}
            element={
              isAuthenticated ? (
                <Navigate to={"/inicio"} replace />
              ) : (
                <Landing />
              )
            }
          />
          <Route
            path={"/*"}
            element={
              isAuthenticated ? <Private /> : <Navigate to={"/"} replace />
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
